import * as React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import _ from 'lodash';
import { FilterButton } from '../../../../../components/ContainerFilters/FilterButton';

export const HoldsFilter: React.FC = () => {
  const controlLabelClasses = {
    label: 'font-medium text-sm py-1',
    root: 'm-0 hover:bg-blue-200 rounded-sm',
  };
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);
  const [filterStates, setFilterStates] = React.useState<string[]>([]);

  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    setFilterStates(searchParams.holdTypes);
  }, [searchParams]);

  const handleOnChange = (holdType: string, v: boolean) => {
    let newFilterStates = filterStates;
    if (holdType === 'all') {
      if (v) {
        newFilterStates = ['all'];
      } else {
        newFilterStates = [];
      }
      setOpen(false);
    } else {
      newFilterStates = newFilterStates.filter((hold: string) => hold !== 'all');
      if (v) {
        newFilterStates.push(holdType);
      } else {
        newFilterStates = newFilterStates.filter((hold: string) => hold !== holdType);
      }
    }
    setSearchParams({
      importStatus: _.uniq(
        _.concat(searchParams.importStatus, ['yard', 'rail', 'unknown', 'vessel'])
      ),
      holdTypes: newFilterStates,
    });
  };

  const clearFilters = () => {
    setSearchParams({ holdTypes: [] });
  };

  return (
    <FilterButton
      title="Holds"
      count={_.keys(_.pickBy(filterStates)).length}
      clearFilter={clearFilters}
      isOpen={open}
      onRequestOpen={setOpen}
    >
      <FormGroup className="px-2">
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('all')}
              onChange={(e) => handleOnChange('all', e.target.checked)}
            />
          }
          label="All holds"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('customs')}
              onChange={(e) => handleOnChange('customs', e.target.checked)}
            />
          }
          label="Customs"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('freight')}
              onChange={(e) => handleOnChange('freight', e.target.checked)}
            />
          }
          label="Freight"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('line')}
              onChange={(e) => handleOnChange('line', e.target.checked)}
            />
          }
          label="Line"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('tmf')}
              onChange={(e) => handleOnChange('tmf', e.target.checked)}
            />
          }
          label="TMF"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('terminal')}
              onChange={(e) => handleOnChange('terminal', e.target.checked)}
            />
          }
          label="Terminal"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('ctf')}
              onChange={(e) => handleOnChange('ctf', e.target.checked)}
            />
          }
          label="CTF"
        />
        <FormControlLabel
          classes={controlLabelClasses}
          control={
            <Checkbox
              size="small"
              checked={filterStates.includes('others')}
              onChange={(e) => handleOnChange('others', e.target.checked)}
            />
          }
          label="Other holds"
        />
      </FormGroup>
    </FilterButton>
  );
};
HoldsFilter.displayName = 'TrackAndTrace.Controls.filters.HoldsFilter';
